import React, { useState } from "react";
import Dropdown from "../../common/dropDown";
//for calendar
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
//for time picekr
import TimePicker from "../../common/timePicker";
//for auto search
import AutoSearch from "../../common/AutoSearch";
//for dual list box
import DualListBox from "../../common/dualListBox";
//for tab
import Tabs from "../../common/tabs";
//for tree view
import TreeView from "../../common/treeView";
//for google doc editor
import GoogleDocsEditor from "../../common/GoogleDocsEditor";
//for org chart tree
import OrgChart from "../../common/orgChart";
//for chips
import Chips from "../../common/chips";
//for checkbox nd radio button
import CheckBox from "../../common/checkBox";
import RadioButton from "../../common/radioButton";
//for input mask
import InputMask from "../../common/inputMask";
//for colorPicker
import ColorPicker from "../../common/colorPicker";
import ListBox from "../../common/ListBox/ListBox";
//for toggle
import Toggle from "../../common/Toggle/Toggle";
//for notification panel
import NotificationPanel from "../../common/NotificationPanel";
//for small cards
import SmallCard from "../../common/smallcards/SmallCard";

const CommonComponent = () => {
  //for calendar
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const minDate = new Date(); // Today
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 5); // Optional
  //calendar

  //drop down
  const options = [
    {
      label: "RedRedRedRedRedd",
      value: "red",
    },
    { label: "Blue", value: "blue" },
    { label: "Green", value: "green" },
    { label: "Pink", value: "Pink" },
    { label: "Mallon", value: "Mallon" },
    { label: "Raddish", value: "Raddish" },
  ];

  const [single, setSingle] = useState("blue");
  const [multi, setMulti] = useState([]);
  console.log(single);

  //auto search
  const volunteers = [
    { id: 1, label: "Test participant", subLabel: "9044895796" },
    { id: 2, label: "test", subLabel: "9999999999" },
    { id: 3, label: "TestArjun Mehra", subLabel: "9876543210" },
    { id: 4, label: "TestDeepa Sharma", subLabel: "8765432198" },
    { id: 5, label: "Rahul Kumar", subLabel: "9988776655" },
    { id: 6, label: "Priya Singh", subLabel: "8877665544" },
    { id: 7, label: "Rohan Das", subLabel: "9090909090" },
    { id: 8, label: "Sneha Patel", subLabel: "9191919191" },
    { id: 9, label: "Amit Joshi", subLabel: "9292929292" },
    { id: 10, label: "Neha Verma", subLabel: "9393939393" },
    { id: 11, label: "Vikram Rao", subLabel: "9494949494" },
    { id: 12, label: "Anita Pandey", subLabel: "9595959595" },
    { id: 13, label: "Suresh Nair", subLabel: "9696969696" },
    { id: 14, label: "Rekha Bhat", subLabel: "9797979797" },
    { id: 15, label: "Mohit Jain", subLabel: "9898989898" },
  ];

  const handleSearch = async (query) => {
    return volunteers.filter((item) =>
      item.label.toLowerCase().includes(query.toLowerCase())
    );
  };

  const handleSelect = (item) => {
    console.log("Selected:", item);
  };

  //dual list box
  const allItems = [
    { value: 1, label: "Alpha" },
    { id: 2, label: "Bravo" },
    { id: 3, label: "Charlie" },
    { id: 4, label: "Delta" },
    { id: 5, label: "Echo" },
    { id: 6, label: "Foxtrot" },
    { id: 7, label: "George" },
    { id: 8, label: "Hannah" },
    { id: 9, label: "India" },
    { id: 10, label: "Juliet" },
    { id: 11, label: "Kevin" },
    { id: 12, label: "Lima" },
    { id: 13, label: "Mike" },
    { id: 14, label: "Nina" },
    { id: 15, label: "Oscar" },
    { id: 16, label: "Papa" },
    { id: 17, label: "Quebec" },
    { id: 18, label: "Romeo" },
    { id: 19, label: "Sierra" },
    { id: 20, label: "Tango" },
    { id: 21, label: "Uma" },
    { id: 22, label: "Victor" },
    { id: 23, label: "Wendy" },
    { id: 24, label: "Xavier" },
    { id: 25, label: "Yankee" },
    { id: 26, label: "Zulu" },
    { id: 27, label: "Aaron" },
    { id: 28, label: "Bella" },
    { id: 29, label: "Caleb" },
    { id: 30, label: "Diana" },
    { id: 31, label: "Ethan" },
    { id: 32, label: "Fiona" },
    { id: 33, label: "Gavin" },
    { id: 34, label: "Hazel" },
    { id: 35, label: "Ian" },
    { id: 36, label: "Jasmine" },
    { id: 37, label: "Kyle" },
    { id: 38, label: "Lara" },
    { id: 39, label: "Mason" },
    { id: 40, label: "Nora" },
    { id: 41, label: "Omar" },
    { id: 42, label: "Penelope" },
    { id: 43, label: "Quinn" },
    { id: 44, label: "Rachel" },
    { id: 45, label: "Sean" },
    { id: 46, label: "Tina" },
    { id: 47, label: "Ulysses" },
  ];

  const fetchSelectedItems = async () => {
    const selectedLabels = await new Promise((resolve) =>
      setTimeout(() => resolve(["Delta", "Echo"]), 500)
    );

    return allItems.filter((item) => selectedLabels.includes(item.label));
  };

  const handleChange = ({ selectedItems, availableItems }) => {
    console.log("Selected:", selectedItems);
    console.log("Available:", availableItems);
    // Send to API if needed
  };
  //for tabs
  const tabData = [
    { label: "Overview", content: <div>Overview content</div>, id: 1 },
    { label: "Details", content: <div>Details content</div>, id: 2 },
    { label: "Analytics", content: <div>Analytics content</div>, id: 3 },
    { label: "SUM", content: <div>SUM</div>, id: 4 },
    {
      label: "Reports",
      content: <div>Reports content</div>,
      id: 5,
      disabled: true,
    },
    { label: "Performance", content: <div>Performance content</div>, id: 6 },
    { label: "Settings", content: <div>Settings content</div>, id: 7 },
    { label: "Users", content: <div>Users content</div>, id: 8 },
    { label: "Roles", content: <div>Roles content</div>, id: 9 },
    { label: "Audit", content: <div>Audit logs</div>, id: 10 },
    {
      label: "Integrations",
      content: <div>Integrations content</div>,
      id: 11,
      disabled: true,
    },
    { label: "Support", content: <div>Support content</div>, id: 12 },
  ];
  const handleTabChange = ({ tab, index }) => {
    console.log("Tab clicked:", index, tab);
    // tab.label, tab.id, tab.content etc available
  };
  //for tree view
  const treeData = [
    {
      id: 1,
      name: "East Area",
      type: "folder",
      children: [
        { id: 20, name: "Comprassor1.pdf", type: "file" },
        {
          id: 2,
          name: "Refrigeration",
          type: "folder",
          children: [
            { id: 21, name: "Comprassor1", type: "folder" },
            { id: 3, name: "Comprassor1.pdf", type: "file" },
            { id: 4, name: "Compressor2.docx", type: "file" },
          ],
        },
        {
          id: 5,
          name: "Process",
          type: "folder",
          children: [
            { id: 6, name: "Valve1.xlsx", type: "file" },
            { id: 7, name: "Valve2.pptx", type: "file" },
            { id: 8, name: "Valve3.txt", type: "file" },
          ],
        },
      ],
    },
    {
      id: 9,
      name: "West Area",
      type: "folder",
      children: [
        {
          id: 10,
          name: "Process",
          type: "folder",
          children: [
            { id: 11, name: "Valve1.xlsx", type: "file" },
            { id: 12, name: "Valve2.txt", type: "file" },
          ],
        },
        {
          id: 13,
          name: "Air Handlers",
          type: "folder",
          children: [
            { id: 14, name: "AU1.docx", type: "file" },
            { id: 15, name: "AU2.pdf", type: "file" },
            { id: 16, name: "my folder", type: "folder" },
          ],
        },
      ],
    },
    {
      id: 17,
      name: "arfin folder",
      type: "folder",
      children: [{ id: 18, name: "Compressor1.pdf", type: "file" }],
    },
  ];
  //for editor
  const [content, setContent] = useState("");
  //for org chart tree

  const sampleData = [
    {
      id: 1,
      name: "Amy Stewart",
      title: "CEO",
      department: "Executive",
      level: 0,
      parentId: null,
      avatar: "👩‍💼",
    },
    {
      id: 2,
      name: "Anna Field",
      title: "VP Sales",
      department: "Sales",
      level: 1,
      parentId: 1,
      avatar: "👩‍💻",
    },
    {
      id: 3,
      name: "Stephen Gross",
      title: "CTO",
      department: "Technology",
      level: 1,
      parentId: 1,
      avatar: "👨‍💻",
    },
    {
      id: 4,
      name: "Maria Rodriguez",
      title: "CFO",
      department: "Finance",
      level: 1,
      parentId: 1,
      avatar: "👩‍💼",
    },
    {
      id: 5,
      name: "James Wilson",
      title: "VP Marketing",
      department: "Marketing",
      level: 1,
      parentId: 1,
      avatar: "👨‍💼",
    },
    {
      id: 6,
      name: "Sarah Johnson",
      title: "Sales Director",
      department: "Sales",
      level: 2,
      parentId: 2,
      avatar: "👩‍💻",
    },
    {
      id: 7,
      name: "Michael Chen",
      title: "Engineering Director",
      department: "Technology",
      level: 2,
      parentId: 3,
      avatar: "👨‍💻",
    },
    {
      id: 8,
      name: "Lisa Wang",
      title: "Product Director",
      department: "Technology",
      level: 2,
      parentId: 3,
      avatar: "👩‍💻",
    },
    {
      id: 9,
      name: "David Brown",
      title: "Finance Director",
      department: "Finance",
      level: 2,
      parentId: 4,
      avatar: "👨‍💼",
    },
    {
      id: 10,
      name: "Emma Davis",
      title: "Marketing Director",
      department: "Marketing",
      level: 2,
      parentId: 5,
      avatar: "👩‍💼",
    },
  ];

  const sampleColors = {
    Executive: "#f3e8ff",
    Sales: "#dbeafe",
    Technology: "#dcfce7",
    Finance: "#fef3c7",
    Marketing: "#fce7f3",
    default: "#f3f4f6",
  };

  const handleNodeClick = (employee) => {
    console.log("Clicked employee:", employee);
  };

  //for chips
  const [techData, setTechData] = useState([
    {
      name: "React",
      disabled: false,
      borderColor: "#3b82f6",
      textColor: "#1e40af",
    },
    {
      name: "JavaScript",
      disabled: false,
      borderColor: "#eab308",
      textColor: "#a16207",
    },
    {
      name: "TypeScript",
      disabled: true,
      borderColor: "#6b7280",
      textColor: "#6b7280",
    },
    {
      name: "Node.js",
      disabled: false,
      borderColor: "#22c55e",
      textColor: "#166534",
    },
    {
      name: "Express",
      disabled: true,
      borderColor: "#6b7280",
      textColor: "#6b7280",
    },
    {
      name: "MongoDB",
      disabled: false,
      borderColor: "#10b981",
      textColor: "#047857",
    },
    {
      name: "PostgreSQL",
      disabled: false,
      borderColor: "#3b82f6",
      textColor: "#1e40af",
    },
    {
      name: "Redis",
      disabled: true,
      borderColor: "#6b7280",
      textColor: "#6b7280",
    },
    {
      name: "Docker",
      disabled: false,
      borderColor: "#06b6d4",
      textColor: "#0891b2",
    },
    {
      name: "Kubernetes",
      disabled: false,
      borderColor: "#8b5cf6",
      textColor: "#7c3aed",
    },
  ]);

  const [selectedTech, setSelectedTech] = useState(["React", "JavaScript"]);

  const handleTechCreate = (newTech) => {
    const newItem = {
      name: newTech,
      disabled: false,
      borderColor: "#d1d5db",
      textColor: "#374151",
    };
    setTechData([...techData, newItem]);
  };

  const handleTechRemove = (removedTech) => {
    setTechData(techData.filter((tech) => tech.name !== removedTech));
  };

  //for checkbox and radio box
  // Simple string arrays
  //options={['Option 1', 'Option 2', 'Option 3']}

  // Or detailed objects with individual control
  const [selectedSkills, setSelectedSkills] = useState(["JavaScript", "React"]);
  const [selectedHobbies, setSelectedHobbies] = useState([]);
  const [selectedColors, setSelectedColors] = useState(["Blue"]);

  // Radio button states
  const [selectedSize, setSelectedSize] = useState("Medium");
  const [selectedPayment, setSelectedPayment] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("Pro");

  // Data arrays
  const skillOptions = [
    { value: "JavaScript", label: "JavaScript" },
    { value: "React", label: "React" },
    { value: "Vue", label: "Vue.js", disabled: true },
    { value: "Angular", label: "Angular" },
    { value: "Node.js", label: "Node.js" },
    { value: "Python", label: "Python" },
  ];

  const hobbyOptions = [
    "Reading",
    "Gaming",
    "Cooking",
    "Traveling",
    "Photography",
  ];

  const colorOptions = [
    { value: "Red", label: "🔴 Red" },
    { value: "Blue", label: "🔵 Blue" },
    { value: "Green", label: "🟢 Green" },
    { value: "Yellow", label: "🟡 Yellow", disabled: true },
  ];

  const sizeOptions = ["Small", "Medium", "Large", "Extra Large"];

  const paymentOptions = [
    { value: "credit", label: "Credit Card" },
    { value: "debit", label: "Debit Card" },
    { value: "paypal", label: "PayPal", disabled: true },
    { value: "crypto", label: "Cryptocurrency" },
  ];

  const planOptions = [
    { value: "Free", label: "Free Plan - $0/month" },
    { value: "Pro", label: "Pro Plan - $29/month" },
    { value: "Enterprise", label: "Enterprise Plan - $99/month" },
  ];

  //for input mask
  const [formData, setFormData] = useState({
    ssn: "",
    phone: "",
    serial: "",
    creditCard: "",
    date: "",
    time: "",
    zipCode: "",
    license: "",
    ein: "",
    isbn: "",
    ip: "",
    mac: "",
  });

  const handleInputChange = (field) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  //for color picker
  const [hexOnlyColor, setHexOnlyColor] = useState("#8000ff");
  const [fullFeaturedColor, setFullFeaturedColor] = useState("#ff6b6b");

  //for toggle
  const [toggleStates, setToggleStates] = useState({
    basic: false,
    withDescription: true,
    disabled: false,
    customColor: true,
  });

  //for ListBox - Simple data object
  const userData = [
    {
      id: 1,
      title: "John Doe",
      subTitle: "john.doe@example.com",
      dataType: "User",
      profilePicture: null,
    },
    {
      id: 2,
      title: "Jane Smith",
      subTitle: " jane.smith@example.com",
      dataType: "User",
      profilePicture: null,
    },
    {
      id: 3,
      title: "Michael Johnson",
      subTitle: "michael.j@example.com",
      dataType: "User",
      profilePicture: null,
    },
  ];
  const studyData = [
    {
      id: 4,
      title: "Clinical Trial A - Phase 1",
      subTitle: "STD-141",
      dataType: "Study",
      studyColor: "#3b82f6",
    },
    {
      id: 5,
      title: "Clinical Trial B - Phase 2",
      subTitle: "STD-142",
      dataType: "Study",
      studyColor: "#8b5cf6",
    },
  ];
  const generalData = [
    {
      id: 6,
      title: "System Admin",
      subTitle: "150 users",
      dataType: "General",
    },
    {
      id: 7,
      title: "Doctor",
      subTitle: "222 users",
      dataType: "General",
    },
  ];

  const handleListBoxSelect = (node) => {
    console.log("Selected node:", node);
  };

  //for notification panel
  const mockNotifications = [
    {
      id: 1,
      title: "Document approved by approver",
      message: "You have new document from user approval",
      additionalText: "Thanks",
      timestamp: new Date("2025-12-16T10:10:00"),
      senderName: "Anderson Jacob",
      senderRole: "approver",
      isRead: false,
    },
    {
      id: 2,
      title: "Document review completed by reviewer",
      message: "You have new document from user review",
      additionalText: "Thanks",
      timestamp: new Date("2025-12-16T10:06:00"),
      senderName: "Hassan Ahmed",
      senderRole: "reviewer",
      isRead: false,
    },
    {
      id: 3,
      title: "Document review completed by reviewer",
      message:
        "You have new document from user review. This is a longer message used to test the Show more and Show less feature in the notification panel component. It should be long enough to exceed the truncation limit so that the toggle button appears correctly.",
      additionalText: "Thanks",
      timestamp: new Date("2025-12-16T09:09:00"),
      senderName: "Hassan Ahmed",
      senderRole: "reviewer",
      isRead: false,
    },
    {
      id: 4,
      title: "Change request raised",
      message: "Dear user you have new document change request",
      timestamp: new Date("2025-12-16T08:30:00"),
      senderName: "Alex Morgan",
      senderRole: "user",
      isRead: true,
    },
  ];

  const [notifications, setNotifications] = useState(mockNotifications);
  const [showSidebar, setShowSidebar] = useState(false);

  const handleMarkAllRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
  };

  const handleMarkAsRead = (id) => {
    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, isRead: true } : n))
    );
  };

  const handleNotificationClick = (notification) => {
    console.log("Notification clicked:", notification);
  };

  return (
    <>
      <div className="container-fluid">
        {/* SmallCard Component Examples */}
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="bg-white p-4 rounded border">
              <h4 className="mb-4">SmallCard Component</h4>
              <div className="row g-3">
                <div className="col-md-3">
                  <SmallCard
                    title="TOTAL FILES & FOLDERS"
                    value="12,642"
                    changeIndicator="+8%"
                    backgroundColor="#fff"
                    iconBgColor="#dbeafe"
                    iconColor="#1d4ed8"
                    fontColor="#1e293b"
                    height="140px"
                  />
                </div>
                <div className="col-md-3">
                  <SmallCard
                    title="ACTIVE USERS"
                    value="2,847"
                    changeIndicator="+12%"
                   
                    backgroundColor="#f8fafc"
                    iconBgColor="#dcfce7"
                    iconColor="#15803d"
                    fontColor="#0f172a"
                    height="140px"
                  />
                </div>
                <div className="col-md-3">
                  <SmallCard
                    title="PENDING REVIEWS"
                    value="89"
                    height="140px"
                    backgroundColor="#fffbeb"
                    iconBgColor="#fef3c7"
                    iconColor="#b45309"
                    fontColor="#1c1917"
                  />
                </div>
                <div className="col-md-3">
                  <SmallCard
                    title="COMPLETED TRIALS"
                    value="156"
                    changeIndicator="-2%"
                    backgroundColor="#f0fdf4"
                    iconBgColor="#d1fae5"
                    iconColor="#047857"
                    fontColor="#064e3b"
                    height="140px"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Toggle Component Examples */}
        <div className="row mb-4">
          <div className="col-md-6">
            <div className="bg-white p-4 rounded border">
              <h5 className="mb-3">Basic Toggle</h5>
              <Toggle
                title="Enable Notifications"
                checked={toggleStates.basic}
                onChange={() =>
                  setToggleStates((prev) => ({
                    ...prev,
                    basic: !prev.basic,
                  }))
                }
              />

              <h5 className="mb-3 mt-4">Toggle with Description</h5>
              <Toggle
                title="Document Uploads"
                description="Notify when new docs are added"
                checked={toggleStates.withDescription}
                onChange={() =>
                  setToggleStates((prev) => ({
                    ...prev,
                    withDescription: !prev.withDescription,
                  }))
                }
              />

              <h5 className="mb-3 mt-4">Disabled Toggle</h5>
              <Toggle
                title="Disabled Feature"
                description="This toggle is disabled"
                checked={toggleStates.disabled}
                onChange={() => {}}
                disabled={true}
              />

              <h5 className="mb-3 mt-4">Toggle with Custom Color</h5>
              <Toggle
                title="Custom Color Toggle"
                description="Toggle with green color (#10b981)"
                checked={toggleStates.customColor}
                onChange={() =>
                  setToggleStates((prev) => ({
                    ...prev,
                    customColor: !prev.customColor,
                  }))
                }
                color="#10b981"
              />
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-3">
            <ListBox
              data={userData}
              onSelect={(item) => {
                handleListBoxSelect(item);
              }}
              selectedId={1}
            />
          </div>
          <div className="col-md-3">
            <ListBox
              data={studyData}
              onSelect={(item) => {
                handleListBoxSelect(item);
              }}
            />
          </div>
          <div className="col-md-3">
            <ListBox
              data={generalData}
              onSelect={(item) => {
                handleListBoxSelect(item);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label>Single Select</label>
            <Dropdown
              options={options}
              selected={single}
              onSelect={setSingle}
            />
          </div>

          <div className="col-md-3">
            <label>Multi Select</label>
            <Dropdown
              options={options}
              isMulti={true}
              selected={multi}
              onSelect={setMulti}
            />
          </div>

          <div className="col-md-3">
            <label>Date Range Picker</label>

            <DatePicker
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={(dates) => {
                const [start, end] = dates;
                setStartDate(start);
                setEndDate(end);
              }}
              isClearable
              placeholderText="From date - To date"
              className="form-control"
            />
          </div>

          <div className="col-md-3">
            <label>Date Picker</label>
            <DatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date)}
              placeholderText="Select date"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              isClearable
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              minDate={minDate}
              maxDate={maxDate}
            />
          </div>
          <div className="col-md-3">
            <label>Time Picker</label>
            <TimePicker
              interval={15}
              onTimeChange={(val) => console.log(val)}
            />
          </div>
          <div className="col-md-3">
            <label>Auto Search</label>
            <AutoSearch
              placeholder="Search employee..."
              minLength={3}
              debounceTime={300}
              onSearch={handleSearch}
              onSelect={handleSelect}
            />
          </div>
          <div className="col-md-6 ">
            <DualListBox
              fetchSelectedItems={fetchSelectedItems}
              allItems={allItems}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-12">
            <label>Tabs</label>
            <Tabs
              tabs={tabData}
              orientation="horizontal"
              onTabChange={handleTabChange}
              defaultActive={0}
            />
          </div>

          <div className="col-md-3">
            <label>Tabs</label>
            <Tabs
              tabs={tabData}
              orientation="vertical"
              onTabChange={handleTabChange}
              defaultActive={0}
            />
          </div>
          <div className="col-md-12 ">
            <TreeView
              data={treeData}
              // onAction={(node, action) => {
              //   console.log("Action:", action, "on", node);
              // }}
              // onSelect={(node) => {
              //   console.log(node);
              // }}
            />
          </div>

          <div className="col-md-12">
            <GoogleDocsEditor
              value={content}
              onChange={setContent}
              // allowImages={config.allowImages}
              // allowPaste={config.allowPaste}
              // allowPasteImages={config.allowPasteImages}
              // disabled={config.disabled}
              // height={config.height}
              placeholder="Start typing..."
            />
          </div>

          <div className="col-md-12">
            <OrgChart
              data={sampleData}
              colors={sampleColors}
              expandAll={false}
              onNodeClick={handleNodeClick}
            />
          </div>

          <div className="col-md-4">
            <Chips
              data={techData}
              selectedChips={selectedTech}
              onSelectionChange={setSelectedTech}
              onCreate={handleTechCreate}
              onRemove={handleTechRemove}
              allowCreate={true}
              allowRemove={true}
              allowSuggestion={true}
              maxLength={15}
              selectedBorderColor="#1d4ed8"
              selectedTextColor="#ffffff"
              selectedBackgroundColor="#3b82f6"
              placeholder="Type to search or create technology..."
            />
          </div>

          <div className="col-md-6">
            <RadioButton
              options={sizeOptions}
              selectedValue={selectedSize}
              onChange={setSelectedSize}
              name="size-selection"
              groupLabel="T-Shirt Size"
              layout="vertical"
              size="medium"
              color="#3b82f6"
            />

            <CheckBox
              options={skillOptions}
              selectedValues={selectedSkills}
              onChange={setSelectedSkills}
              groupLabel="Programming Skills"
              layout="vertical"
              size="medium"
              color="#3b82f6"
            />
          </div>
          <div className="row">
            {/* SSN */}
            <div className="col-md-6">
              <InputMask
                id="ssn"
                label="SSN"
                mask="999-99-9999"
                placeholder="999-99-9999"
                value={formData.ssn}
                onChange={handleInputChange("ssn")}
                required
              />
            </div>

            {/* Phone */}
            <div className="col-md-6">
              <InputMask
                id="phone"
                label="Phone"
                mask="(999) 999-9999"
                placeholder="(999) 999-9999"
                value={formData.phone}
                onChange={handleInputChange("phone")}
              />
            </div>

            {/* Serial Number */}
            <div className="col-md-6">
              <InputMask
                id="serial"
                label="Serial"
                mask="aa*-999-a999"
                placeholder="aa*-999-a999"
                value={formData.serial}
                onChange={handleInputChange("serial")}
              />
            </div>

            {/* Credit Card */}
            <div className="col-md-6">
              <InputMask
                id="creditCard"
                label="Credit Card"
                mask="9999-9999-9999-9999"
                placeholder="9999-9999-9999-9999"
                value={formData.creditCard}
                onChange={handleInputChange("creditCard")}
              />
            </div>

            {/* Date */}
            <div className="col-md-6">
              <InputMask
                id="date"
                label="Date (MM/DD/YYYY)"
                mask="99/99/9999"
                placeholder="MM/DD/YYYY"
                value={formData.date}
                onChange={handleInputChange("date")}
              />
            </div>

            {/* Time */}
            <div className="col-md-6">
              <InputMask
                id="time"
                label="Time (HH:MM)"
                mask="99:99"
                placeholder="HH:MM"
                value={formData.time}
                onChange={handleInputChange("time")}
              />
            </div>

            {/* ZIP Code */}
            <div className="col-md-6">
              <InputMask
                id="zipCode"
                label="ZIP Code"
                mask="99999-9999"
                placeholder="12345-6789"
                value={formData.zipCode}
                onChange={handleInputChange("zipCode")}
              />
            </div>

            {/* Driver License */}
            <div className="col-md-6">
              <InputMask
                id="license"
                label="Driver License"
                mask="AAA-999-999"
                placeholder="ABC-123-456"
                value={formData.license}
                onChange={handleInputChange("license")}
              />
            </div>

            {/* EIN (Employer ID) */}
            <div className="col-md-6">
              <InputMask
                id="ein"
                label="EIN (Employer ID)"
                mask="99-9999999"
                placeholder="12-3456789"
                value={formData.ein}
                onChange={handleInputChange("ein")}
              />
            </div>

            {/* ISBN */}
            <div className="col-md-6">
              <InputMask
                id="isbn"
                label="ISBN"
                mask="999-9-999-99999-9"
                placeholder="978-0-123-45678-9"
                value={formData.isbn}
                onChange={handleInputChange("isbn")}
              />
            </div>

            {/* IP Address */}
            <div className="col-md-6">
              <InputMask
                id="ip"
                label="IP Address"
                mask="999.999.999.999"
                placeholder="192.168.1.1"
                value={formData.ip}
                onChange={handleInputChange("ip")}
              />
            </div>

            {/* MAC Address */}
            <div className="col-md-6">
              <InputMask
                id="mac"
                label="MAC Address"
                mask="**:**:**:**:**:**"
                placeholder="AA:BB:CC:DD:EE:FF"
                value={formData.mac}
                onChange={handleInputChange("mac")}
              />
            </div>
          </div>

          {/* Form Data Display */}
          <div className="mt-5">
            <h3>Form Data</h3>
            <div className="bg-light p-3 rounded">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>SSN:</strong> {formData.ssn || "Not entered"}
                  </p>
                  <p>
                    <strong>Phone:</strong> {formData.phone || "Not entered"}
                  </p>
                  <p>
                    <strong>Serial:</strong> {formData.serial || "Not entered"}
                  </p>
                  <p>
                    <strong>Credit Card:</strong>{" "}
                    {formData.creditCard || "Not entered"}
                  </p>
                  <p>
                    <strong>Date:</strong> {formData.date || "Not entered"}
                  </p>
                  <p>
                    <strong>Time:</strong> {formData.time || "Not entered"}
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <strong>ZIP Code:</strong>{" "}
                    {formData.zipCode || "Not entered"}
                  </p>
                  <p>
                    <strong>License:</strong>{" "}
                    {formData.license || "Not entered"}
                  </p>
                  <p>
                    <strong>EIN:</strong> {formData.ein || "Not entered"}
                  </p>
                  <p>
                    <strong>ISBN:</strong> {formData.isbn || "Not entered"}
                  </p>
                  <p>
                    <strong>IP Address:</strong> {formData.ip || "Not entered"}
                  </p>
                  <p>
                    <strong>MAC Address:</strong>{" "}
                    {formData.mac || "Not entered"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Mask Legend */}
          <div className="mt-4">
            <h4>Mask Character Legend</h4>
            <div className="bg-info bg-opacity-10 p-3 rounded">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <code>9</code> - Digit (0-9)
                  </p>
                  <p>
                    <code>a</code> - Letter (a-z, A-Z)
                  </p>
                  <p>
                    <code>*</code> - Alphanumeric (a-z, A-Z, 0-9)
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <code>A</code> - Uppercase letter (A-Z)
                  </p>
                  <p>
                    <code>L</code> - Lowercase letter (a-z)
                  </p>
                  <p>
                    <code>#</code> - Number (0-9)
                  </p>
                </div>
              </div>
              <p className="mb-0">
                <strong>Note:</strong> Any other characters in the mask (like
                hyphens, parentheses, spaces) are treated as literal characters.
              </p>
            </div>
          </div>
        </div>
        {/* for color picker */}
        <div className="col-md-4">
          <ColorPicker
            label="HEX Color Picker"
            value={hexOnlyColor}
            onChange={setHexOnlyColor}
            format="hex"
            enabledFormats={["hex"]} // Only HEX format
            showAlpha={false}
            showPresets={true}
            showInput={true}
            showCopyButton={true}
            style={{ background: hexOnlyColor }}
          />
        </div>

        {/* Notification Panel Component Examples */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="bg-white p-4 rounded border">
              <h4 className="mb-4">Notification Panel Component</h4>

              <div className="mb-4">
                <h5 className="mb-3">Sidebar Variant</h5>
                <button
                  className="btn btn-primary mb-3"
                  onClick={() => setShowSidebar(true)}
                >
                  Open Notification Sidebar
                </button>
                <NotificationPanel
                  variant="sidebar"
                  isOpen={showSidebar}
                  notifications={notifications}
                  onClose={() => setShowSidebar(false)}
                  onMarkAllRead={handleMarkAllRead}
                  onMarkAsRead={handleMarkAsRead}
                  onNotificationClick={handleNotificationClick}
                />
              </div>
              <div className="mb-4">
                <h5 className="mb-3">Inline Variant (for UserProfile page)</h5>
                <NotificationPanel
                  variant="inline"
                  notifications={notifications}
                  onMarkAllRead={handleMarkAllRead}
                  onMarkAsRead={handleMarkAsRead}
                  onNotificationClick={handleNotificationClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CommonComponent;
